<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view></router-view>
    </div>
  </a-config-provider>
</template>

<script>
import ANTDZHCN from "ant-design-vue/lib/locale-provider/zh_CN";

export default {
  name: "App",
  data() {
    return {
      locale: ANTDZHCN,
    };
  },
};
</script>

<style lang="less">
@import "~normalize.css/normalize.css";
// @import "//at.alicdn.com/t/font_2538469_1uysl0tg5ma.css";
@import "~ant-design-vue/dist/antd.less";
@import "./theme.less";
@import "./iconfont/iconfont.css";

* {
  box-sizing: border-box;
}

body {
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
}

#app {
  width: 100vw;
  height: 100vh;
}

.icon-yichu {
  color: #dd6d22;
}
.icon-bianji {
  color: #22dd90;
}
.icon-jinyong {
  color: #dd6d22;
}
.icon-shanchu1 {
  color: #dd6d22;
}
.icon-qiyong {
  color: #22dd90;
}
.icon-icon-user,
.icon-beizhu,
.icon-shijian,
.icon-jianzhuguanli,
.icon-jiaoseleixing {
  color: #0f9f64;
}
.icon-daping1 {
  color: #dbe5ee;
}
</style>
